import { parsePhoneNumber } from 'libphonenumber-js/max';

const {
    headoffice: { country_iso3166_alpha2 },
} = Mobi2Go;

export const getCountryAndNationalPhoneNumberFromRawPhoneNumber = raw_phone_number => {
    let parsed_phone_number = parsePhoneNumber(
        raw_phone_number,
        country_iso3166_alpha2
    );
    if (
        !parsed_phone_number.isValid() &&
        raw_phone_number.substr(0, 1) !== '+'
    ) {
        parsed_phone_number = parsePhoneNumber(
            `+${raw_phone_number}`,
            country_iso3166_alpha2
        );
    }
    if (parsed_phone_number.isValid()) {
        return [
            parsed_phone_number.format('NATIONAL'),
            parsed_phone_number.country,
        ];
    }
    return [raw_phone_number, country_iso3166_alpha2];
};

export const getE164PhoneNumberFromCountryAndNationalPhoneNumber = (
    country,
    national_phone_number
) => {
    const parsed_phone_number = parsePhoneNumber(
        national_phone_number,
        country
    );
    if (!parsed_phone_number.isValid()) {
        throw new Error('Invalid phone_number number');
    }
    return parsed_phone_number.format('E.164');
};
